export default __webpack_public_path__ + "static/6_17_fit-80c87a09ca82a2c54b574bac78759749.png";